import { createAction, createSlice } from '@reduxjs/toolkit';

export const loadModelsRequest = createAction('models/loadModelsRequest');
export const setShowModels = createAction('models/setShowModels');
export const addCatalogueRequest = createAction('models/addCatalogueRequest');
export const updateCatalogueRequest = createAction('models/updateCatalogueRequest');
export const deleteCatalogueRequest = createAction('models/deleteCatalogueRequest');

const initialState = {
    models: [],
    items: [],
    nextToken: null,
    count: 0,
    loading: false,
    loaded: false,
    error: null,
    showModels: false,
    addUpdateLoading: false,
    addUpdateError: null,
};

const modelsSlice = createSlice({
    name: 'models',
    initialState,
    reducers: {
        fetchModelsStart(state) {
            state.loading = true;
            state.error = null;
        },
        fetchModelsSuccess(state, action) {
            state.loading = false;
            state.loaded = true;
            state.models = action.payload.models;
            state.items = action.payload.items || [];
            state.nextToken = action.payload.nextToken || null;
            state.count = action.payload.count || 0;
        },
        fetchModelsFailure(state, action) {
            state.loading = false;
            state.loaded = false;
            state.error = action.payload.error;
        },
        setShowModelsState(state, action) {
            state.showModels = action.payload;
        },
        addCatalogueStart(state) {
            state.addUpdateLoading = true;
            state.addUpdateError = null;
        },
        addCatalogueSuccess(state, action) {
            state.addUpdateLoading = false;
            state.items.push(action.payload.item);
            // Also add to models dropdown if name and id exist
            if (action.payload.item.name && action.payload.item.id) {
                state.models.push({
                    label: action.payload.item.name,
                    value: action.payload.item.id,
                    extendedWarranty: action.payload.item.extWarrantyPeriodInDays,
                    warrantyPeriodInDays: action.payload.item.warrantyPeriodInDays,
                    extWarrantyPeriodInDays: action.payload.item.extWarrantyPeriodInDays
                });
            }
        },
        addCatalogueFailure(state, action) {
            state.addUpdateLoading = false;
            state.addUpdateError = action.payload.error;
        },
        updateCatalogueStart(state) {
            state.addUpdateLoading = true;
            state.addUpdateError = null;
        },
        updateCatalogueSuccess(state, action) {
            state.addUpdateLoading = false;
            const index = state.items.findIndex(item => item.id === action.payload.item.id);
            if (index !== -1) {
                state.items[index] = action.payload.item;
            }
            // Update models dropdown if name changed
            const modelIndex = state.models.findIndex(model => model.value === action.payload.item.id);
            if (modelIndex !== -1) {
                state.models[modelIndex].label = action.payload.item.name;
                state.models[modelIndex].extendedWarranty = action.payload.item.extWarrantyPeriodInDays;
                state.models[modelIndex].warrantyPeriodInDays = action.payload.item.warrantyPeriodInDays;
                state.models[modelIndex].extWarrantyPeriodInDays = action.payload.item.extWarrantyPeriodInDays;
            }
        },
        updateCatalogueFailure(state, action) {
            state.addUpdateLoading = false;
            state.addUpdateError = action.payload.error;
        },
        deleteCatalogueStart(state) {
            state.addUpdateLoading = true;
            state.addUpdateError = null;
        },
        deleteCatalogueSuccess(state, action) {
            state.addUpdateLoading = false;
            // Remove from items array
            state.items = state.items.filter(item => item.id !== action.payload.id);
            // Remove from models dropdown
            state.models = state.models.filter(model => model.value !== action.payload.id);
        },
        deleteCatalogueFailure(state, action) {
            state.addUpdateLoading = false;
            state.addUpdateError = action.payload.error;
        },
    },
});

export const { 
    fetchModelsStart, 
    fetchModelsSuccess, 
    fetchModelsFailure, 
    setShowModelsState,
    addCatalogueStart,
    addCatalogueSuccess,
    addCatalogueFailure,
    updateCatalogueStart,
    updateCatalogueSuccess,
    updateCatalogueFailure,
    deleteCatalogueStart,
    deleteCatalogueSuccess,
    deleteCatalogueFailure
} = modelsSlice.actions;

export default modelsSlice.reducer;